
import { CustomIcons } from 'lion-vue';
import Vue from 'vue';

import Vuetify, {
  VApp,
  VAvatar,
  VBadge,
  VAutocomplete,
  VChip,
  VDatePicker,
  VDivider,
  VNavigationDrawer,
  VFooter,
  VList,
  VMenu,
  VBtn,
  VTabs,
  VIcon,
  VSelect,
  VSwitch,
  VTextarea,
  VToolbar,
  VTooltip,
  VDialog,
  VProgressLinear,
  VProgressCircular,
  VForm,
  VCard,
  VHover,
  VTextField,
  VSnackbar,
  VDataTable,
  VBtnToggle,
  VCheckbox,
  VPagination,
  VRadioGroup,
  VCombobox,
  VExpansionPanel,
  VTreeview,
  VDataIterator,
  VWindow,
  transitions,
  VImg,
  VStepper,
  VLayout,
  VFlex,
  VListTile,
  VListTileAction,
  VListTileContent,
  VListTileTitle,
  VToolbarTitle,
  VSpacer,
  VToolbarItems,
  VContent,
  VContainer,
  VTab,
  VCardTitle,
  VCardText,
  VCardActions,
} from 'vuetify/lib';


Vue.use(Vuetify, {
  components: {
    VCardActions,
    VContent,
    VContainer,
    VTab,
    VCardTitle,
    VCardText,
    VListTileTitle,
    VToolbarTitle,
    VSpacer,
    VToolbarItems,
    VListTileContent,
    VListTileAction,
    VListTile,
    VFlex,
    VApp,
    VAvatar,
    VBadge,
    VAutocomplete,
    VChip,
    VDatePicker,
    VDivider,
    VNavigationDrawer,
    VFooter,
    VList,
    VMenu,
    VBtn,
    VTabs,
    VIcon,
    VSelect,
    VSwitch,
    VTextarea,
    VToolbar,
    VTooltip,
    VDialog,
    VProgressLinear,
    VProgressCircular,
    VForm,
    VCard,
    VHover,
    VTextField,
    VSnackbar,
    VDataTable,
    VBtnToggle,
    VCheckbox,
    VPagination,
    VRadioGroup,
    VCombobox,
    transitions,
    VExpansionPanel,
    VTreeview,
    VDataIterator,
    VWindow,
    VImg,
    VStepper,
    VLayout,
  },
  theme: {
    primary: '#235EA1',
    secondary: '#424242',
    accent: '#3D96BE',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107',
    text: '#333333',
    background: '#7F7F7F',
    primaryv2: '#248B9F',
  },
  options: {
    customProperties: true,
  },
  icons: {
    ...CustomIcons,
  },
});
